<template>
  <!-- prettier-ignore -->
  <div class="collective">
    <div class="collective-toggle">
      <label v-text="$t('person.collective.toggle')" />
      <ovp-icon
        v-tooltip="$t('person.collective.toggleTooltip')"
        class="collective-toggle__tooltip"
        art="light"
        name="circle-info"
      />
      <ovp-radio-group
        name="isCollective"
        :value="!!form.contractNumber"
        :items="collectiveItems"
        @update="toggle"
      />
    </div>

    <ovp-text-input
      class="collective__input"
      readonly
      name="contractNumber"
      :value="form.contractNumber"
      :hint="$t('person.collective.placeholder')"
      :theme="theme"
      :title="$t('person.collective.number')"
      :validate="v.contractNumber"
    />
  </div>
</template>

<script>
export default {
  name: 'OvpPersonsCollective',

  model: {
    prop: 'value',
    event: 'update',
  },

  props: {
    theme: {
      type: String,
      default: 'light',
    },

    v: {
      type: Object,
      required: true,
    },

    value: {
      type: Object,
      required: true,
    },
  },

  data() {
    return {
      contractNumber: this.value.contractNumber,
      form: this.value,
    }
  },

  computed: {
    collectiveItems() {
      return [
        {
          value: true,
          text: 'form.yes',
        },
        {
          value: false,
          text: 'form.no',
        },
      ]
    },
  },

  methods: {
    toggle(value) {
      if (!value) {
        this.form.contractNumber = null
      } else {
        this.form.contractNumber = this.contractNumber
      }
      this.v.contractNumber.$touch()
    },
  },
}
</script>

<style name="mobile" scoped>
.collective {
  padding: 20px 0 0 0;
  display: flex;
  flex-direction: column;

  &-toggle {
    padding: 0 0 15px 5px;

    label {
      font-size: 12px;
      color: var(--c-black);
    }

    &__tooltip {
      margin: 0 0 0 5px;
    }
  }
}
</style>

<style name="desktop" scoped>
@media (--md) {
  .collective {
    flex-direction: row;

    &-toggle {
      padding: 0 0 0 5px;
      flex: 0 0 250px;
    }

    &__input {
      margin-left: 30px;
      flex: 0 0 300px;
    }
  }
}
</style>
